<template>
  <div class="pay_list">
    <dl>
      <dt>订单编号：{{businessId}}</dt>
      <dd>
        <img v-if="params.cover" :src="params.cover" class="list_img" />
        <img v-if="!params.cover || params.cover==''" src="@/assets/images/live_img.jpg" class="list_img" />
        <h3>{{params.name}}</h3>
        <p class="price_a">金额 ¥<span>{{params.cost}}</span>元</p>
      </dd>
    </dl>
  </div>
</template>
<script>
export default {
  name: 'coursePayInfo',
  props: ['businessID', 'productID'],
  data () {
    return {
      productId: this.productID,
      businessId: this.businessID,
      params: {},
      result: {}
    }
  },
  created () {
    this.getLivePlay(this.productId)
  },
  methods: {
    getLivePlay (id) {
      this.$api.get(this.$global.livePlayApiPath, '/livePlayInfo/get', {id: id}, r => {
        if (r.data) {
          this.params = r.data
          this.result = {
            money: this.params.cost,
            subject: this.params.name
          }
          this.$emit('success', this.result)
        }
      })
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/page/modules/livePlay/pay_info.vue